import { createContext } from 'react';

import { Features } from '@src/contexts/features-context/types';

export const FeaturesContext = createContext<Features>({
  guestAccount: {
    active: false,
  },
  memberBenefits: {
    active: false,
  },
  npsSurveyCopyAbExperiment: {
    active: false,
  },
  upgradeUpsell: {
    active: false,
  },
  tmNativeSignupModal: {
    active: false,
  },
  tmEnableVoucherFakeDoorTest: {
    active: false,
  },
});
export const FeaturesProvider = FeaturesContext.Provider;
